import { render, staticRenderFns } from "./ViewCodeSandbox.vue?vue&type=template&id=f07aac6a&scoped=true"
import script from "./ViewCodeSandbox.vue?vue&type=script&lang=js"
export * from "./ViewCodeSandbox.vue?vue&type=script&lang=js"
import style0 from "./ViewCodeSandbox.vue?vue&type=style&index=0&id=f07aac6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07aac6a",
  null
  
)

export default component.exports